import { createOnboardingServiceApi as generatedCreateOnboardingServiceApi } from '../generated/onboarding/createOnboardingService';

import { getOnboardProfileDraftApi } from './getOnboardProfileDraft';

const createOnboardingServiceApi = generatedCreateOnboardingServiceApi.enhanceEndpoints({
  endpoints: {
    createOnboardingService: {
      invalidatesTags: ['Onboard'],
      onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            getOnboardProfileDraftApi.util.updateQueryData('getOnboardProfileDraft', undefined, (draft) => {
              if (draft.services != null) {
                draft.services.push(data);
              } else {
                draft.services = [data];
              }

              if (draft.progress != null) {
                draft.progress.services = true;
              } else {
                draft.progress = { services: true };
              }
            }),
          );
        } catch {
          // Do nothing on error - cache will be invalidated.
        }
      },
    },
  },
});

export const { useCreateOnboardingServiceMutation } = createOnboardingServiceApi;
